import type Owner from '@ember/owner';
import Route from '@ember/routing/route';
import type { Registry as Services } from '@ember/service';
import { service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';
import { BudgetForecastDataFetching } from 'lumen/utils/budget-forecast/data-fetching';
import protectedRoute from 'lumen/utils/decorators/protected-route';

interface BudgetIndexModel {
  entries: typeof BudgetForecastDataFetching.prototype.fetchEntriesTask;
}

@protectedRoute({
  features: 'business_intelligence.settings.budget_and_forecast',
  redirectTo: 'hotel.settings',
})
export default class HotelSettingsBudgetIndexRoute extends Route {
  @service declare navigation: Services['navigation'];

  #dataFetching: BudgetForecastDataFetching;

  constructor(owner: Owner) {
    super(owner);
    this.#dataFetching = new BudgetForecastDataFetching(owner);
  }

  beforeModel(transition: Transition): void {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }
  }

  deactivate(): void {
    this.#dataFetching.cancelAll();
    this.#dataFetching.unloadAll();
  }

  model(): BudgetIndexModel {
    const model: BudgetIndexModel = {
      entries: this.#dataFetching.fetchEntriesTask,
    };

    void model.entries.perform('budget');

    return model;
  }
}
